import { render, staticRenderFns } from "./LicenseManagement.vue?vue&type=template&id=2d21b1b8&scoped=true"
import script from "./LicenseManagement.vue?vue&type=script&lang=js"
export * from "./LicenseManagement.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d21b1b8",
  null
  
)

export default component.exports